import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import styles from './RecentSearchesHeader.module.scss';

export const RecentSearchesHeader = () => {
	return (
		<div>
			<Typography className={styles.recentSearchesHeader} variant='label1'>
				Recent searches
			</Typography>
			<div className={`aa-SourceHeaderLine ${styles.recentSearchesHeaderLine}`} />
		</div>
	);
};
